export default "__VITE_ASSET__B9nINbo___"